import { Length, LengthPercentage } from "@siteimprove/alfa-css";
import { Longhand } from "../longhand.js";
import { Resolver } from "../resolver.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/text-indent}
 * @internal
 */
export default Longhand.of(Length.of(0, "px"), LengthPercentage.parse, (textIndent, style) => textIndent.map(LengthPercentage.partiallyResolve(Resolver.length(style))), { inherits: true });
//# sourceMappingURL=text-indent.js.map